import { MobileAppBanner } from "@app/mobile-app/components";
import { OfflineDuesBanner } from "@app/session-history/components/OfflineDuesBanner";
import { useFeatureFlag } from "@app/shared/hooks/use-feature-flag";
import { cn } from "@design-system/lib/utils";
import { DarkModeToggle } from "../../DarkModeToggle";
import { HeaderTopBar, HeaderUserMenu, NotificationsBell } from "./index";
import { HeaderLogo } from "./HeaderLogo";
import { InquiriesShortcut } from "./InquiriesShortcut";
import { useIsLoggedIn } from "@framework/account/hooks";
import { userAtom } from "@framework/config/atoms/user-atom";

type HeaderMobileProps = {
  isScrolled: boolean;
};

export function HeaderMobile({ isScrolled }: HeaderMobileProps) {
  const isDarkModeFeatureEnabled = useFeatureFlag("darkMode");
  const isNotificationsFeatureEnabled = useFeatureFlag("notifications");
  const isLoggedIn = useIsLoggedIn();
  const user = userAtom.useValue();

  return (
    <>
      <header
        className={cn(
          "sticky top-0 z-40 w-full border-b border-slate-200/70 bg-white/90 backdrop-blur-xl transition-[background-color,box-shadow,border-color] duration-300 dark:border-slate-800/70 dark:bg-slate-950/90",
          isScrolled &&
            "border-slate-200/90 bg-white/95 shadow-[0_10px_32px_-22px_rgba(15,23,42,0.5)] dark:border-slate-800 dark:bg-slate-950/95",
        )}
      >
        {/* Top Bar */}
        <MobileAppBanner />
        <OfflineDuesBanner />
        <HeaderTopBar />

        {/* Main Header Content */}
        <div>
          <div className="container mx-auto flex h-[4.25rem] items-center justify-between gap-3 px-4 sm:px-6">
            {/* Logo & Brand */}
            <div className="flex items-center">
              <HeaderLogo />
            </div>

            {/* Right Actions for Mobile */}
            <div className="flex items-center gap-1 rounded-2xl border border-slate-200/80 bg-white/75 p-1 shadow-sm dark:border-slate-800 dark:bg-slate-900/75">
              {/* User's first name */}
              {isLoggedIn && user && (
                <span className="hidden max-w-[100px] truncate px-1 text-sm font-bold text-slate-700 dark:text-slate-200 sm:block">
                  {user.name.split(" ")[0]}
                </span>
              )}

              {/* Dark Mode Toggle */}
              {isDarkModeFeatureEnabled && (
                <DarkModeToggle variant="switch" size="sm" className="p-2" />
              )}

              <InquiriesShortcut />
              {isNotificationsFeatureEnabled && <NotificationsBell />}

              <HeaderUserMenu compact={false} />
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
